import Vue from "vue";

import DxDrawer from "devextreme-vue/drawer";
import DxScrollView from "devextreme-vue/scroll-view";

import DxForm, {
  DxGroupItem,
  DxSimpleItem,
  DxLabel,
} from "devextreme-vue/form";

import DxButton from "devextreme-vue/button";

import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import DxValidationSummary from "devextreme-vue/validation-summary";
import DxTreeView from "devextreme-vue/ui/tree-view";
import DxTabs from "devextreme-vue/tabs";
import { DxLoadPanel } from "devextreme-vue/load-panel";

import {
  DxNumberBox,
  DxTextBox,
  DxColorBox,
  DxCheckBox,
  DxTextArea,
} from "devextreme-vue";

import { DxAutocomplete } from "devextreme-vue/autocomplete";

import { DxDateBox } from "devextreme-vue/date-box";

import {
  DxValidator,
  DxCustomRule,
  DxRangeRule,
  DxRequiredRule,
  DxAsyncRule,
} from "devextreme-vue/validator";

import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxSearchPanel,
  DxEditing,
  DxScrolling,
  DxLookup,
  DxExport,
  DxKeyboardNavigation,
  DxFilterPanel, DxStateStoring,
} from "devextreme-vue/data-grid";

import DxRadioGroup from "devextreme-vue/radio-group";

import { DxSelection } from "devextreme-vue/data-grid";
import DxSelectBox from "devextreme-vue/select-box";

import { DxDropDownButton } from "devextreme-vue";
import GcPopupValidationSummary from "./gc-popup-validation-summary";
import GcPopupAlert from "./gc-popup-alert";
import GcPopupAudit from "./gc-popup-audit";
import GcHeaderContentDynamic from "./gc-header-content-dynamic";
import GcHeaderContentStatic from "./gc-header-content-static";
import GcSplitView from "./gc-split-view";
import GcTabs from "./gc-tabs";
import GcFilterSplitView from "./gc-filter-split-view";
import GcNumberPad from "./gc-number-pad";
import GcInactive from "./gc-inactive";
import GcStatusChip from "./gc-status-chip";

import GcHeaderGeneralLedgerEnquiry from "./gc-header-general-ledger-enquiry";
import GcStockTransferBatchDetails from "./gc-batch-stock-transfer";
import GcBatchDespatchOrderDetails from "./gc-batch-despatch-order";
import GcBatchGoodsIn from "./gc-batch-goods-in";
import GcBatchGoodsReturn from "./gc-batch-goods-return";
import GcFooterSalesOrder from "./gc-footer-sales-order";
import GcBatchStockAdjustment from "./gc-batch-stock-adjustment";
import GcBatchStocktakeReview from "./gc-batch-stocktake-review";

import GcHeaderToolbar from "./gc-header-toolbar";
import GcSideNavMenu from "./gc-side-nav-menu";
import GcGridProductSelection from "./gc-grid-product-selection";
import GcBarcodeParser from "./gc-barcode-parser";
import GcFooterScanBarcode from "./gc-footer-scan-barcode";
import GcSaveButton from "./gc-footer-save-button";
import GcForm from "./gc-form";
import GcFieldTag from "./gc-field-tag";
import GcFieldDate from "./gc-field-date";
import GcFilterPanel from "./gc-filter-panel";
import GcFormReport from "./gc-form-report";
import GcFieldSelect from "./gc-field-select";
import GcReportPdf from "./gc-report-pdf";
import GcMenuCellTemplate from "./gc-menu-cell-template";
import GcFieldCheckBox from "./gc-field-checkbox";
import GcPopup from "./gc-popup";
import GcFormHeaderToolbar from "./gc-form-header-toolbar";
import GcHeaderForm from "./gc-header-form";
import GcDataGrid from "./gc-data-grid";
import GcFooter from "./gc-footer";
import GcFooterItem from "./gc-footer-item";
import GcImageUpload from "./gc-image-upload";
import GcFieldRadio from "./gc-field-radio";
import GcChildGrid from "./gc-child-grid";
import GcCheckboxHeader from "./gc-checkbox-header";
import GcGridCheckBox from "./gc-grid-checkbox";
import GcRecord from "./gc-record";
import GcRecordCell from "./gc-record-cell";
// import GcDataGridV2 from "./gc-data-grid-v2";

import GcPrintPreview from "./gc-button-print-preview";
import GcEmail from "./gc-button-email";
import GcPrint from "./gc-button-print";
import GcToolbarPrintPreview from "./gc-toolbar-button-print-preview";
import GcToolbarEmail from "./gc-toolbar-button-email";
import GcRecordDelete from "./gc-button-delete.vue";
import GcGauge from "./gc-gauge.vue";

import gcFieldSelectOperator from "./gc-field-select-operator";
import gcFieldNumberSelectOperator from "./gc-field-number-box-operator";

// ROAMCX
import GcRoamHeaderToolbar from "./gc-roam-header-toolbar";
import GcRoamHeaderContentDynamic from "./gc-roam-header-content-dynamic";

import { DxMasterDetail } from "devextreme-vue/data-grid";

import { DxSummary, DxTotalItem } from "devextreme-vue/data-grid";
import { DxTooltip } from "devextreme-vue/tooltip";
import GcDecimal from "./gc-decimal";
import GcDecimalCell from "./gc-decimal-cell";

import { DxSwitch } from 'devextreme-vue/switch';
import Keypress from "vue-keypress";
import GcProductKits from "./gc-product-kits"
import { DxBox, DxItem as DxBoxItem } from "devextreme-vue/box";


import { DxFileUploader } from "devextreme-vue/file-uploader";

import GcHotKey from './gc-hot-key';

export function RegisterBaseComponents() {
  // eslint-disable-next-line no-console
  // this.$logger.debug("Registering devexpress components globally");
  Vue.component("DxFileUploader", DxFileUploader);
  Vue.component("GcHotKey", GcHotKey);
  Vue.component("DxBox", DxBox);
  Vue.component("DxBoxItem", DxBoxItem);
  Vue.component("GcProductKits", GcProductKits);
  Vue.component("DxSwitch", DxSwitch);
  Vue.component("Keypress", Keypress);
  Vue.component("DxStateStoring", DxStateStoring);
  Vue.component("DxFilterPanel", DxFilterPanel);
  Vue.component("GcRecordCell", GcRecordCell);
  Vue.component("GcDecimalCell", GcDecimalCell);
  Vue.component("GcGauge", GcGauge);
  Vue.component("GcDecimal", GcDecimal);
  Vue.component("DxTooltip", DxTooltip);
  Vue.component("DxMasterDetail", DxMasterDetail);
  Vue.component("DxSummary", DxSummary);
  Vue.component("DxTotalItem", DxTotalItem);
  Vue.component("DxDrawer", DxDrawer);
  Vue.component("DxEditing", DxEditing);
  Vue.component("DxScrollView", DxScrollView);
  Vue.component("DxScrolling", DxScrolling);
  Vue.component("DxDataGrid", DxDataGrid);
  Vue.component("DxColumn", DxColumn);
  Vue.component("DxLookup", DxLookup);
  Vue.component("DxFilterRow", DxFilterRow);
  Vue.component("DxPager", DxPager);
  Vue.component("DxPaging", DxPaging);
  Vue.component("DxSearchPanel", DxSearchPanel);
  Vue.component("DxPopup", DxPopup);
  Vue.component("DxToolbarItem", DxToolbarItem);
  Vue.component("DxScrollView", DxScrollView);
  Vue.component("DxValidationSummary", DxValidationSummary);
  Vue.component("DxToolbar", DxToolbar);
  Vue.component("DxItem", DxItem);
  Vue.component("DxRangeRule", DxRangeRule);
  Vue.component("DxRequiredRule", DxRequiredRule);
  Vue.component("DxCustomRule", DxCustomRule);
  Vue.component("DxAsyncRule", DxAsyncRule);
  Vue.component("DxValidationSummary", DxValidationSummary);
  Vue.component("DxForm", DxForm);
  Vue.component("DxGroupItem", DxGroupItem);
  Vue.component("DxSimpleItem", DxSimpleItem);
  Vue.component("DxLabel", DxLabel);
  Vue.component("DxButton", DxButton);
  Vue.component("DxTreeView", DxTreeView);
  Vue.component("DxTextBox", DxTextBox);
  Vue.component("DxDateBox", DxDateBox);
  Vue.component("DxDropDownButton", DxDropDownButton);
  Vue.component("DxNumberBox", DxNumberBox);
  Vue.component("DxColorBox", DxColorBox);
  Vue.component("DxCheckBox", DxCheckBox);
  Vue.component("DxAutocomplete", DxAutocomplete);
  Vue.component("DxValidator", DxValidator);
  Vue.component("DxTabs", DxTabs);
  Vue.component("DxSelection", DxSelection);
  Vue.component("DxLoadPanel", DxLoadPanel);
  Vue.component("DxRadioGroup", DxRadioGroup);
  Vue.component("DxSelectBox", DxSelectBox);
  Vue.component("GcPopupValidationSummary", GcPopupValidationSummary);
  Vue.component("GcPopupAlert", GcPopupAlert);
  Vue.component("GcPopupAudit", GcPopupAudit);
  Vue.component("GcHeaderContentDynamic", GcHeaderContentDynamic);
  Vue.component("GcHeaderContentStatic", GcHeaderContentStatic);
  Vue.component("GcSplitView", GcSplitView);
  Vue.component("GcTabs", GcTabs);

  Vue.component("GcFilterSplitView", GcFilterSplitView);
  Vue.component("GcNumberPad", GcNumberPad);
  Vue.component("GcInactive", GcInactive);
  Vue.component("GcStatusChip", GcStatusChip);

  Vue.component("GcHeaderGeneralLedgerEnquiry", GcHeaderGeneralLedgerEnquiry);
  Vue.component("DxExport", DxExport);
  Vue.component("GcStockTransferBatchDetails", GcStockTransferBatchDetails);

  Vue.component("GcBatchDespatchOrderDetails", GcBatchDespatchOrderDetails);
  Vue.component("GcBatchGoodsIn", GcBatchGoodsIn);
  Vue.component("GcBatchGoodsReturn", GcBatchGoodsReturn);
  Vue.component("GcFooterSalesOrder", GcFooterSalesOrder);
  Vue.component("GcBatchStockAdjustment", GcBatchStockAdjustment);
  Vue.component("GcBatchStocktakeReview", GcBatchStocktakeReview);

  Vue.component("GcHeaderToolbar", GcHeaderToolbar);
  Vue.component("GcSideNavMenu", GcSideNavMenu);
  Vue.component("GcGridProductSelection", GcGridProductSelection);
  Vue.component("GcBarcodeParser", GcBarcodeParser);
  Vue.component("GcFooterScanBarcode", GcFooterScanBarcode);
  Vue.component("GcSaveButton", GcSaveButton);

  Vue.component("GcForm", GcForm);
  Vue.component("GcFieldTag", GcFieldTag);
  Vue.component("GcFieldDate", GcFieldDate);
  Vue.component("GcFilterPanel", GcFilterPanel);
  Vue.component("GcFormReport", GcFormReport);
  Vue.component("GcFieldSelect", GcFieldSelect);
  Vue.component("GcReportPdf", GcReportPdf);
  Vue.component("GcMenuCellTemplate", GcMenuCellTemplate);
  Vue.component("GcFieldCheckBox", GcFieldCheckBox);
  Vue.component("GcPopup", GcPopup);
  Vue.component("GcFormHeaderToolbar", GcFormHeaderToolbar);
  Vue.component("GcHeaderForm", GcHeaderForm);
  Vue.component("GcDataGrid", GcDataGrid);
  Vue.component("GcFooter", GcFooter);
  Vue.component("GcFooterItem", GcFooterItem);
  Vue.component("GcImageUpload", GcImageUpload);
  Vue.component("GcFieldRadio", GcFieldRadio);
  Vue.component("GcChildGrid", GcChildGrid);
  Vue.component("GcCheckboxHeader", GcCheckboxHeader);
  Vue.component("GcGridCheckBox", GcGridCheckBox);
  Vue.component("GcRecord", GcRecord);
  Vue.component("DxTextArea", DxTextArea);
  Vue.component("DxKeyboardNavigation", DxKeyboardNavigation);

  Vue.component("GcPrintPreview", GcPrintPreview);
  Vue.component("GcEmail", GcEmail);
  Vue.component("GcPrint", GcPrint);
  // Vue.component("GcDataGridV2", GcDataGridV2);
  Vue.component("gcFieldSelectOperator", gcFieldSelectOperator);
  Vue.component("GcToolbarPrintPreview", GcToolbarPrintPreview);
  Vue.component("GcToolbarEmail", GcToolbarEmail);
  Vue.component("GcRecordDelete", GcRecordDelete);
  Vue.component("gcFieldNumberSelectOperator", gcFieldNumberSelectOperator);

  // ROAMCX
  Vue.component("GcRoamHeaderToolbar", GcRoamHeaderToolbar);
  Vue.component("GcRoamHeaderContentDynamic", GcRoamHeaderContentDynamic);
}

import notify from "devextreme/ui/notify";
import { alert, confirm } from "devextreme/ui/dialog";

Vue.prototype.$notify = notify;
Vue.prototype.$alert = alert;
Vue.prototype.$confirm = confirm;
